<template>
  <div>
    <div class="form-check">
      <input
        class="form-check-input"
        name="changePassword"
        type="radio"
        id="old-password"
        :value="false"
        v-model="editing"
      />
      <label class="form-check-label" for="old-password">Zadrži staru lozinku</label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        name="changePassword"
        type="radio"
        id="new-password"
        :value="true"
        v-model="editing"
      />
      <label class="form-check-label" for="new-password">Nova lozinka</label>
    </div>
    <div v-if="editing">
      <input
        id="password"
        type="password"
        class="form-control"
        name="password"
        required
        placeholder="unesi novu lozinku"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editing: false
    };
  },
  methods: {
    edit() {
      this.editing = true;
    }
  }
};
</script>